/**
 * @module
 * @format
 */

/**
 * @import {Valid} from '@acng/frontend-rubicon'
 */
import {ARRAY, ENUM, INTEGER, NULLABLE, OBJECT, OPTIONAL, STRING, TUPLE} from '@acng/frontend-rubicon';
import {BOOLEAN} from '@acng/frontend-rubicon';
import {FSK_LEVEL} from './fsk.js';
import {TRANSLATIONS} from './lang.js';

/**
 * Validate the id of an amateur.
 */
const asAmateurId = STRING;

/**
 * @typedef {Valid<asAmateurId>} AmateurId
 */

const asAmateurIdList = /* @__PURE__ */ ARRAY(asAmateurId);

/**
 * @typedef {Valid<AMATEUR_DATA>} AmateurData
 */

const AMATEUR_DATA = /* @__PURE__ */ (() =>
  OBJECT({
    id: asAmateurId,
    nickname: STRING,
    nickname_fsk: FSK_LEVEL,
    intlname: STRING,
    message_price: INTEGER,
    images: ARRAY(TUPLE(INTEGER, FSK_LEVEL, STRING)),
    matchmaker_image: INTEGER,
    languages: ARRAY(
      ENUM(/** @type {const} */ (['de', 'el', 'en', 'es', 'fr', 'it', 'sv', 'cs', 'pl', 'ru', 'nl'])),
    ),
    features: ARRAY(
      ENUM(
        /** @type {const} */ ([
          'chat',
          'livecam',
          'voice_messages',
          'games',
          'weblog',
          'livedating',
          'marketing',
        ]),
      ),
    ),
    do_not_show_in: ARRAY(STRING),
    niche_tags: ARRAY(STRING),
    tags: ARRAY(STRING),
    topics: ARRAY(STRING),
    profile_video_fsk: OPTIONAL(NULLABLE(FSK_LEVEL)),
    profile_video_path: OPTIONAL(NULLABLE(STRING)),

    about_me: NULLABLE(TRANSLATIONS),
    description: NULLABLE(TRANSLATIONS),
    fantasies: NULLABLE(TRANSLATIONS),
    others_about_me: NULLABLE(TRANSLATIONS),

    experiences: ARRAY(TUPLE(FSK_LEVEL, INTEGER)),
    lookingfor: ARRAY(TUPLE(FSK_LEVEL, INTEGER)),
    preferences: ARRAY(TUPLE(FSK_LEVEL, INTEGER)),

    gender: ENUM(/** @type {const} */ (['f', 'm'])),
    age: INTEGER,
    height: OPTIONAL(NULLABLE(INTEGER)),
    weight: OPTIONAL(NULLABLE(INTEGER)),
    country: STRING,
    zip_area: INTEGER,
    body: OPTIONAL(STRING),
    bodyhair: OPTIONAL(STRING),
    eyecolor: OPTIONAL(STRING),
    brasize: OPTIONAL(STRING),
    ethnic: OPTIONAL(STRING),
    glasses: OPTIONAL(STRING),
    haircolor: OPTIONAL(STRING),
    hairlength: OPTIONAL(STRING),
    marital: OPTIONAL(STRING),
    piercings: OPTIONAL(STRING),
    pubichair: OPTIONAL(STRING),
    smoking: OPTIONAL(STRING),
    tattoos: OPTIONAL(STRING),
    penislength: OPTIONAL(STRING),
    penisperimeter: OPTIONAL(STRING),
  }))();

DEBUG: AMATEUR_DATA.explain = 'AMATEUR_DATA';

const asAmateurIs = /* @__PURE__ */ OBJECT({
  online: BOOLEAN,
  offline: BOOLEAN,
});

/**
 * @typedef {Valid<asAmateurIs>} AmateurIsData
 */

export {
  //
  asAmateurIdList,
  AMATEUR_DATA,
  asAmateurIs,
};
